import { render, staticRenderFns } from "./BasicV2.vue?vue&type=template&id=35c4204f&scoped=true"
import script from "./BasicV2.vue?vue&type=script&lang=js"
export * from "./BasicV2.vue?vue&type=script&lang=js"
import style0 from "./BasicV2.vue?vue&type=style&index=0&id=35c4204f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c4204f",
  null
  
)

export default component.exports